const FONT_SIZE = 13
const FOCUS_BORDER_COLOR = 'var(--dark-purple)'

const buttonBaseSx = { textTransform: 'none' }

export const searchButtonSx = {
  ...buttonBaseSx,
  backgroundColor: 'var(--babylon-violet)',
  '&:hover': { backgroundColor: 'var(--babylon-violet-dark)' },
}

export const resetButtonSx = {
  ...buttonBaseSx,
  backgroundColor: 'var(--reset-orange)',
  '&:hover': { backgroundColor: 'var(--reset-orange-dark)' },
}

export const reassignButtonSx = {
  ...buttonBaseSx,
  backgroundColor: 'var(--babylon-violet)',
  '&:hover': { backgroundColor: 'var(--babylon-violet-dark)' },
  '&.Mui-disabled': {
    backgroundColor: 'var(--babylon-violet)',
    color: 'var(--white)',
    opacity: 0.65,
  },
}

export const radioCheckedSx = {
  '&.Mui-checked': { color: FOCUS_BORDER_COLOR },
}

export const textFieldSx = {
  '& .MuiOutlinedInput-root': {
    fontSize: FONT_SIZE,
    '&.Mui-focused fieldset': { borderColor: FOCUS_BORDER_COLOR },
  },
}

export const selectSx = {
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: FOCUS_BORDER_COLOR,
  },
  fontSize: FONT_SIZE,
}

export const menuItemSx = {
  fontSize: FONT_SIZE,
}

export const autocompleteSx = {
  '& .MuiOutlinedInput-root': {
    fontSize: FONT_SIZE,
    '&.Mui-focused fieldset': { borderColor: FOCUS_BORDER_COLOR },
  },
}

export const dialogConfirmButtonSx = {
  ...buttonBaseSx,
  backgroundColor: 'var(--babylon-violet)',
  color: 'var(--white)',
  borderRadius: '8px',
  padding: '6px 16px',
  '&:hover': { backgroundColor: 'var(--babylon-violet-dark)' },
}

export const dialogCancelButtonSx = {
  ...buttonBaseSx,
  color: 'var(--dark-grey)',
  border: '1px solid #ccc',
  borderRadius: '8px',
  padding: '6px 16px',
}

export const reassignSpinnerSx = {
  color: 'var(--babylon-violet)',
}

export const dialogPaperSx = {
  padding: '24px',
  borderRadius: '12px',
  minWidth: 480,
  minHeight: 200,
}

export const dialogPaperCenteredSx = {
  ...dialogPaperSx,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export const dialogTitleSx = {
  fontWeight: 'bold',
  padding: 0,
  paddingBottom: '16px',
}

export const dialogBodySx = {
  whiteSpace: 'pre-line',
}

export const dialogContentSx = {
  padding: 0,
}

export const dialogActionsSx = {
  padding: 0,
  paddingTop: '36px',
  gap: '4px',
}

export const dialogCenteredContentSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  flex: 1,
}

export const dialogStatusTextSx = {
  marginTop: 2,
  fontSize: 16,
}

export const dialogErrorTextSx = {
  marginTop: 2,
  fontSize: 16,
  color: 'var(--warning-tag-border)',
}
